import api from '@/libs/api'
import store from '@/store'

const projectId = () => store.state.app.projectId

export default {
  namespaced: true,
  state: {
    fetchingCorsSettings: false,
    fetchingCorsSettingsById: false,
    corsSettings: [],
    addingCorsSettings: false,
    updatingCorsSettings: false,
    bucketsResultInfo: null,
    deletingCorsSettings: false,
  },
  mutations: {
    SET_FETCHING_CORS_SETTINGS(state, value) {
      state.fetchingCorsSettings = value
    },
    SET_CORS_SETTINGS(state, data) {
      state.corsSettings = data.result
      state.bucketsResultInfo = data.resultInfo
    },
    SET_ADDING_CORS_SETTINGS(state, value) {
      state.addingCorsSettings = value
    },
    SET_UPDATING_CORS_SETTINGS(state, value) {
      state.updatingCorsSettings = value
    },
    SET_DELETING_CORS_SETTINGS(state, value) {
      state.deletingCorsSettings = value
    },
    SET_FETCHING_CORS_SETTINGS_BY_ID(state, value) {
      state.fetchingCorsSettingsById = value
    },
  },
  actions: {
    fetchCorsSettings({ commit }, query) {
      commit('SET_FETCHING_CORS_SETTINGS', true)
      return new Promise((resolve, reject) => {
        api('storage').get(`/v2/projects/${projectId()}/account/${query.accountId}/buckets/${query.bucketName}/cors`)
          .then(response => {
            commit('SET_CORS_SETTINGS', response.data)
            resolve(response)
          })
          .catch(error => {
            commit('SET_CORS_SETTINGS', { result: [], resultInfo: null })
            reject(error)
          })
          .finally(() => { commit('SET_FETCHING_CORS_SETTINGS', false) })
      })
    },
    fetchCorsSettingsById({ commit }, query) {
      commit('SET_FETCHING_CORS_SETTINGS_BY_ID', true)
      return new Promise((resolve, reject) => {
        api('storage').get(`/v2/projects/${projectId()}/account/${query.accountId}/buckets/${query.bucketName}/cors/${query.corsId}`)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_FETCHING_CORS_SETTINGS_BY_ID', false) })
      })
    },
    addCorsSettings({ commit }, query) {
      commit('SET_ADDING_CORS_SETTINGS', true)
      return new Promise((resolve, reject) => {
        api('storage').post(`/v2/projects/${projectId()}/account/${query.accountId}/buckets/${query.bucketName}/cors`, { ...query.cors })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_ADDING_CORS_SETTINGS', false) })
      })
    },
    updateCorsSettings({ commit }, query) {
      commit('SET_UPDATING_CORS_SETTINGS', true)
      return new Promise((resolve, reject) => {
        api('storage').put(`/v2/projects/${projectId()}/account/${query.accountId}/buckets/${query.bucketName}/cors`, { ...query.cors })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_UPDATING_CORS_SETTINGS', false) })
      })
    },
    deleteCorsSettings({ commit }, query) {
      commit('SET_DELETING_CORS_SETTINGS', true)
      return new Promise((resolve, reject) => {
        api('storage').delete(`/v2/projects/${projectId()}/account/${query.accountId}/buckets/${query.bucketName}/cors/${query.corsId}`)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_DELETING_CORS_SETTINGS', false) })
      })
    },
  },

}
